import { render } from "./Votes.vue?vue&type=template&id=f0ed6c72"
import script from "./Votes.vue?vue&type=script&lang=js"
export * from "./Votes.vue?vue&type=script&lang=js"
script.render = render

export default script